import { useContext } from 'react';
import CurrencyContext from '../contexts/CurrencyContext';

const useCurrencyContext = () => useContext(CurrencyContext);

export default useCurrencyContext;
